<template>
  <div id="content-mapa">
    <l-map
      :zoom="zoom"
      :center="center"
      :options="mapOptions"
      :style="style_map"
      @update:center="centerUpdate"
      @update:zoom="zoomUpdate"
    >
      <l-tile-layer :url="url" :attribution="attribution" />
      <l-marker :lat-lng="ubicacion_matriz" :icon="icon_matriz">
        <l-popup>
          <div>
            <b><i class="fas fa-home"></i></b> Matriz
          </div>
        </l-popup>
      </l-marker>
      <l-marker
        :lat-lng="direccion2LatLng(p)"
        v-for="(p, i) in pedidos"
        :key="i"
        :icon="icon"
        @click="mostrarPopup(p)"
        v-on:popupclose="cerrarPopup"
        ref="mostrar-market"
      >
        <l-popup>
          <div v-if="pedido_aux">
            <h5 class="text-center" style="color:#bf0900">
              Pedido
              <b>{{ pedido_aux.id | pedido_id2folio }}</b>
            </h5>
            <p>
              <b><i class="fas fa-home"></i> Dirección </b>:
              {{
                pedido_aux.direccion.calle +
                  ", " +
                  pedido_aux.direccion.colonia +
                  ", " +
                  pedido_aux.direccion.municipio +
                  ", CP: " +
                  pedido_aux.direccion.cp
              }}
            </p>
            <p>
              <b><i class="fas fa-street-view"></i> Distancia </b>:
              {{ distancia(pedido_aux.direccion) }} Km
            </p>
            <p>
              <b><i class="fas fa-comments"></i> Comentario:</b>
              {{ pedido_aux.direccion.comentario }}
            </p>
            <button
              class="btn btn-block btn-sm btn-primary"
              @click="asignarRepartidorModal()"
            >
              Asignar repartidor
            </button>
          </div>
          <div v-else>
            <h6>No esta definido el pedido_aux</h6>
            <pre>{{ pedido_aux }}</pre>
          </div>
        </l-popup>
      </l-marker>
      <!-- controles -->
      <l-control class="list-group" id="lista-pedidos" v-if="pedidos.length">
        <a
          href="#"
          class="list-group-item list-group-item-action"
          v-for="(p, i) in pedidos"
          :key="i"
        >
          <b>{{ p.total | moneda }}</b>
          {{ p.created | dateTime }}
          <span class="badge badge-primary badge-pill">
            {{ p.id | pedido_id2folio }}
          </span>
        </a>
      </l-control>

      <l-control :position="'bottomleft'" class="custom-control-watermark">
        Hay {{ pedidos.length }} pedidos en producción
      </l-control>
      <!-- controles -->
      <!-- linea de punto en punto -->
      <l-polyline
        v-if="puntos_linea.length == 2"
        :lat-lngs="puntos_linea"
        color="#A00C1F"
      ></l-polyline>
    </l-map>
    <!-- Modal repartidores -->
    <modalSeleccionarRepartidor
      v-if="pedido_aux"
      v-model="pedido_aux"
      v-on:asignar-pedido="asignar_pedido"
      ref="selecRepartidor"
    />
  </div>
</template>

<script>
import { latLng, icon } from "leaflet";
// import io from 'socket.io-client';

import {
  LMap,
  LTileLayer,
  LMarker,
  LPopup,
  LControl,
  LPolyline
} from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import Pedido from "@/apis/Pedido";
import modalSeleccionarRepartidor from "@/views/repartidores/modalSeleccionar";

export default {
  name: "PedidosProduccion",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LControl,
    LPolyline,
    modalSeleccionarRepartidor
  },
  data() {
    return {
      pedido_aux: null,
      pedidos: [],
      direcciones: [],
      zoom: 13,
      style_map: "height: 300px; width: 100%",
      center: latLng(17.063677, -96.751236),
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      ubicacion_matriz: latLng(17.063677, -96.751236),
      puntos_linea: [],
      currentZoom: 10.5,
      currentCenter: latLng(17.063677, -96.751236),
      mapOptions: {
        zoomSnap: 0.5
      },
      icon_matriz: icon({
        iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
        iconUrl: require("../../assets/marker_matriz.png"),
        shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
        iconSize: [27, 35],
        iconAnchor: [27, 35]
      }),
      icon: icon({
        iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
        iconUrl: require("../../assets/marker.png"),
        shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
        iconSize: [27, 35],
        iconAnchor: [27, 35]
      })
    };
  },
  created() {
    Pedido.en_produccion().then(d => {
      this.direcciones = d.data.direcciones;
      this.pedidos = d.data.pedidos;
    });
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.resize();
    });
    this.$nextTick(function() {
      window.dispatchEvent(new Event("resize"));
    });
    /*
    const socket = io.connect('http://localhost:3000');
    socket.emit('login', {
      email: 'user@mundosica.com',
      token: this.$store.state.token
    });
    socket.on('datos_de_acceso', function(data) {
      alert("Datos de acceso");
      alert(JSON.stringify(data));
    });
    */
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resize);
  },
  methods: {
    mostrar_market: function() {
      /* console.log("index: " + index);
      console.log(); */
      this.$refs["mostrar-market"][0].$listeners.click();
      // this.$refs['mostrar-market'].click();
    },
    resize: function() {
      let barra = document.getElementById("barra-superior");
      let h = 300;
      if (barra != null) {
        let btop = document.getElementById("barra-superior").offsetHeight + 5;
        h = window.innerHeight - btop;
      } else {
        setTimeout(() => {
          this.resize();
        }, 1000);
        return;
      }
      this.style_map = `height: ${h}px; width: 100%`;
    }, // resize
    asignar_pedido: function() {
      location.reload();
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    asignarRepartidorModal() {
      this.$nextTick(function() {
        this.$refs.selecRepartidor.mostrar_repartidores(this.pedido_aux);
      });
    },
    mostrarPopup(pedido) {
      this.pedido_aux = pedido;
      for (let i in this.direcciones) {
        if (this.direcciones[i].id == pedido.pedidos_movil.direccion_id) {
          this.pedido_aux.direccion = this.direcciones[i];
          break;
        }
      }
      // Pintamos la linea
      this.puntos_linea.splice(0, this.puntos_linea.length);
      this.puntos_linea.push([
        this.ubicacion_matriz.lat,
        this.ubicacion_matriz.lng
      ]);
      this.puntos_linea.push([
        this.pedido_aux.direccion.lat,
        this.pedido_aux.direccion.lng
      ]);
    },
    cerrarPopup() {
      this.puntos_linea.splice(0, this.puntos_linea.length);
    },
    // distance between two geographical points using spherical law of cosines approximation
    distancia(direccion) {
      return this.distance(
        this.ubicacion_matriz,
        latLng(direccion.lat, direccion.lng)
      );
    },
    distance(latlng1, latlng2) {
      let R = 6371000;
      var rad = Math.PI / 180,
        lat1 = latlng1.lat * rad,
        lat2 = latlng2.lat * rad,
        sinDLat = Math.sin(((latlng2.lat - latlng1.lat) * rad) / 2),
        sinDLon = Math.sin(((latlng2.lng - latlng1.lng) * rad) / 2),
        a =
          sinDLat * sinDLat +
          Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon,
        c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return parseFloat((R * c) / 1000).toFixed(2);
    },
    direccion2LatLng(pedido) {
      let d = { lat: 17.063677, lng: -96.751236 };
      for (let i in this.direcciones) {
        if (this.direcciones[i].id == pedido.pedidos_movil.direccion_id) {
          d = this.direcciones[i];
          break;
        }
      }
      return latLng(d.lat, d.lng);
    }
  }
};
</script>

<style>
#content-mapa {
  margin-top: -1.4rem;
}
/** **/
.control-content {
  background: #fff;
  padding: 0 0.5em;
  border: 1px solid #aaa;
  border-radius: 0.1em;
}
.custom-control-watermark {
  opacity: 0.6;
  font-size: 200%;
  font-weight: bolder;
  text-shadow: 2px 2px 2px #f2efe9, -2px -2px 2px #f2efe9;
  color: #553d01;
}

#lista-pedidos {
  opacity: 0.9;
  overflow-y: scroll;
  max-height: 300px;
}
#lista-pedidos:hover {
  opacity: 1;
}
</style>
